
export const mergeIntoDocument = (originalHtml, editedBodyHtml) => {
  const body = editedBodyHtml ?? "";

  if (!originalHtml || !/<body[^>]*>/i.test(originalHtml)) return body;
  if (/<body[^>]*>/i.test(body)) return body;

  return originalHtml.replace(
    /(<body[^>]*>)[\s\S]*?(<\/body>)/i,
    (match, openTag, closeTag) => `${openTag}${body}${closeTag}`
  );
};

export default mergeIntoDocument;
